import 'lodash';

angular.module('lodashAngular', [])
  .run(() => {
    if (!window || !window._) {
      throw new Error('Js library \'Lo-Dash\' is not available! You either misspelled ' +
        'the lib name or forgot to load it. Please check http://lodash.com/');
    }
  })
  .factory('_', () => {
    if (window && window._) {
      return window._;
    }

    throw new Error('Js library \'Lo-Dash\' is not available! You either misspelled ' +
      'the lib name or forgot to load it. Please check  http://lodash.com/');
  });
